__turbopack_context__.v({
  "actions": "authForm-module-scss-module__1UTihq__actions",
  "backLink": "authForm-module-scss-module__1UTihq__backLink",
  "confirmationHeading": "authForm-module-scss-module__1UTihq__confirmationHeading",
  "confirmationMessage": "authForm-module-scss-module__1UTihq__confirmationMessage",
  "confirmationText": "authForm-module-scss-module__1UTihq__confirmationText",
  "description": "authForm-module-scss-module__1UTihq__description",
  "emailHighlight": "authForm-module-scss-module__1UTihq__emailHighlight",
  "fieldsWrapper": "authForm-module-scss-module__1UTihq__fieldsWrapper",
  "form": "authForm-module-scss-module__1UTihq__form",
  "resetButton": "authForm-module-scss-module__1UTihq__resetButton",
});
